define.alias("shared/components/shared/wizard/cancel-button", "preview-grid/components/shared/wizard/cancel-button");